import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { esIdioma, IDIOMA_PER_DEFECTE, type Idioma } from './index';
import {
  formataData,
  formataDataHora,
  formataDataLlarga,
  formataDurada,
  formataHora,
  formataNumero,
  formataPercentatge,
} from './format';

export function useIdioma(): Idioma {
  const { i18n } = useTranslation();
  const lng = i18n.resolvedLanguage ?? i18n.language;
  return esIdioma(lng) ? lng : IDIOMA_PER_DEFECTE;
}

export function useFormat() {
  const idioma = useIdioma();
  return useMemo(
    () => ({
      idioma,
      data: (v: string | number | Date) => formataData(v, idioma),
      hora: (v: string | number | Date) => formataHora(v, idioma),
      dataHora: (v: string | number | Date) => formataDataHora(v, idioma),
      dataLlarga: (v: string | number | Date) => formataDataLlarga(v, idioma),
      numero: (v: number, decimals?: number) => formataNumero(v, idioma, decimals),
      percentatge: (v: number, decimals?: number) => formataPercentatge(v, idioma, decimals),
      durada: formataDurada,
    }),
    [idioma],
  );
}
